import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams, useSearchParams } from "react-router-dom";
import { D1PdfPageSelectionEditCard } from "./edit_card";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const D1PdfPageSelectionEdit = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const client = searchParams.get("client") || Clients.D1;

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <D1PdfPageSelectionEditCard
          id={Number(id)}
          client={client}
          table_name={Tables.D1_PDF_PAGE_SELECTION}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={Tables.D1_PDF_PAGE_SELECTION}
        />
      </div>
    </div>
  );
};
